<template>
    <ModalDefaultInner
        v-model="showDefaultModal"
        :modal-data="inputModalData"
        @cta="action"
        @cancel="cancelAction"
        size="2xl"
    >
        <template #icon>
            <CardIcon type="success">
                <PencilSquareIcon />
            </CardIcon>
        </template>

        <FormInput ref="input" v-model="modalData.input" @keydown.enter.native="action" />
    </ModalDefaultInner>
</template>

<script>
import { CardIcon } from "@easy/ui/cards";
import { FormInput } from "@easy/ui/forms";
import { PencilSquareIcon } from "@easy/ui/icons";
import { ModalDefaultInner } from "@easy/ui/modals";

export default {
    components: {
        ModalDefaultInner,
        CardIcon,
        PencilSquareIcon,
        FormInput,
    },
    props: {
        modalData: Object,
    },
    data() {
        return {
            showDefaultModal: false,
            inputModalData: {
                title: this.modalData.title,
                input: this.modalData.input,
                description: this.modalData.desc,
                ctaLabel: this.modalData.actionBtn,
                cancelLabel: this.modalData.cancelBtn,
            },
        };
    },
    mounted() {
        // Autofocus on input:
        const { $el } = this.$refs["input"];
        if ($el) {
            const input = $el.querySelector("input");
            input?.focus();
        }
    },
    methods: {
        action() {
            this.modalData.callback();
            this.$emit("close");
        },
        action2() {
            this.modalData.callback2();
            this.$emit("close");
        },
        cancelAction() {
            if (this.modalData.cancelCallback) {
                this.modalData.cancelCallback();
            }
            this.$emit("close");
        },
    },
};
</script>
